module.exports = __webpack_public_path__ + "static/media/global_outlook.259df1a3.png";